import { AbstractModel, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Driver } from './driver';

@inheritSerialization(AbstractModel)
export class TransitProgramDriverInfo {
  @autoserialize
  transitProgramId: number;

  @autoserialize
  stateCode: string;

  @autoserialize
  transitProgramCode: string;

  @autoserializeAs(Driver)
  driver: Driver;

  @autoserialize
  active: boolean;

  @autoserialize
  approved: boolean;

  @autoserializeAs(Date)
  firstApprovedDate: Date;

  @autoserialize
  enabled: boolean;

  @autoserializeAs(Date)
  firstEnabledDate: Date;

  /**** Serialization ****/

  static OnSerialized(instance: TransitProgramDriverInfo, json: any): void {
    if (!isNullOrUndefined(instance.firstApprovedDate)) {
      json.firstApprovedDate = instance.firstApprovedDate.getTime();
    }

    if (!isNullOrUndefined(instance.firstEnabledDate)) {
      json.firstEnabledDate = instance.firstEnabledDate.getTime();
    }
  }

  static OnDeserialized(instance: TransitProgramDriverInfo, json: any): void {
    if (!isNullOrUndefined(json['firstApprovedDate'])) {
      instance.firstApprovedDate = new Date(json['firstApprovedDate']);
    }

    if (!isNullOrUndefined(json['firstEnabledDate'])) {
      instance.firstEnabledDate = new Date(json['firstEnabledDate']);
    }
  }
}
